import store from 'Store'
import events from 'Store/events'

export const TYPE = {
  NONE: 'none',
  URL: 'url'
}

export const TRIGGER = {
  RINGING: 'ringing',
  ANSWERED: 'answered'
}

export function handleRequest (trigger, req) {
  if (!Object.values(TRIGGER).includes(trigger)) {
    events.pubError(`Invalid screenpop trigger: "${trigger}"`)
    return
  }

  const userConf = getUserConf()

  const requestConf = parseHeader(req.getHeader('X-Screen-Pop-Conf') || '')
  const requestVars = parseHeader(req.getHeader('X-Screen-Pop-Vars') || '')

  if (requestConf.type === TYPE.URL) {
    // conf is read from request header
    let conf = requestConf

    // or overridden by user
    if (conf.allow_override === 'true' && userConf.type === TYPE.URL) {
      conf = userConf
    }

    // do nothing if trigger does not match
    if (trigger !== conf.trigger) {
      return
    }

    // replace template vars in url and open window
    const url = replaceTemplateVars(conf.url, requestVars)
    openWindow(url)
  }
}

export function getUserConf () {
  return store.getters['settings/screenPop']
}

export function parseHeader (header) {
  const props = header
    .split(';') // split properties
    .map(prop => prop.trim()) // trim white spaces
    .filter(prop => prop) // filter empty items
    .map(prop => prop.split('=')) // split names and values
    .map(prop => [prop[0], decodeURIComponent(prop[1])]) // decode values

  return Object.fromEntries(props)
}

export function replaceTemplateVars (string, vars) {
  Object.entries(vars).forEach(([name, value]) => {
    string = string.replace(new RegExp(`{{${name}}}`, 'gi'), value)
  })

  return string
}

export function openWindow (url) {
  // open url in new window
  const width = 1024
  const height = 768
  const left = (window.screen.width - width) / 2

  const newWindow = window.open(
    url,
    '_blank',
    `width=${width},height=${height},left=${left},resizable=yes,scrollbars=yes,toolbar=yes,menubar=yes`
  )

  // if new window cant open, display screenpop link in snack bar
  if (!newWindow || newWindow.closed) {
    // truncate displayed URL to max 40 characters with ellipsis if needed
    const displayUrl = url.length > 40 ? url.substring(0, 40) + '...' : url

    events.pubNotify({
      text: `Screen Pop URL: <a target="_blank" href="${url}" class="white--text">${displayUrl}</a>`,
      raw: true,
      timeout: 10000
    })
  }
}

export default {
  TYPE,
  TRIGGER,
  handleRequest,
  getUserConf,
  parseHeader,
  replaceTemplateVars,
  openWindow
}
